import UndoIcon from "@mui/icons-material/Undo";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMemo, useState } from "react";
import { useLoaderData, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Request from "../../../../components/request/Request";
import CustomerInvoiceOnlinePayment from "../../../../components/payment-gateway/CustomerInvoiceOnlinePayment";
import PaymentSummaryWidget from "../../../../components/payment-gateway/PaymentSummaryWidget";
import RequestInvoicesPaymentPanel from "../../../../components/payment-gateway/RequestInvoicesPaymentPanel";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import PaymentSelection from "../PaymentSelection";
import CustomerPricingActionPanel from "../CustomerPricingActionPanel";

const CustomerRequestsInfoPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const urlRequestId = searchParams.get("id");
  const requestPrimaryKey = useMemo(() => {
    const fromLoader = data?.request?.id ?? data?.request?.Id;
    if (fromLoader != null && fromLoader !== "") {
      const numeric = Number(fromLoader);
      return Number.isNaN(numeric) || numeric <= 0 ? null : numeric;
    }
    if (!urlRequestId) return null;
    const numeric = Number(urlRequestId);
    return Number.isNaN(numeric) || numeric <= 0 ? null : numeric;
  }, [data?.request?.id, data?.request?.Id, urlRequestId]);
  const requestId = requestPrimaryKey;
  const invoiceIdParam = searchParams.get("invoiceId");
  const invoiceId = invoiceIdParam ? Number(invoiceIdParam) : null;

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPaymentData, setSelectedPaymentData] = useState(null);

  const onNavigateToListPage = () => {
    navigate("/SLN/Customer/Requests");
  };

  const handleOpenPaymentModal = () => {
    setPaymentModalOpen(true);
  };

  const handleClosePaymentModal = () => {
    setPaymentModalOpen(false);
  };

  const handlePaymentSelected = async (paymentData) => {
    try {
      setSelectedPaymentData({
        paymentId: paymentData.id,
        paymentTitle: paymentData.title,
      });

      setTimeout(() => {
        handleClosePaymentModal();
      }, 100);

      toast.success(
        `روش پرداخت "${paymentData.title}" با موفقیت انتخاب و ثبت شد!`
      );
    } catch (error) {
      console.error("خطا در ثبت انتخاب روش پرداخت:", error);
      toast.error("خطا در ثبت انتخاب روش پرداخت");
    }
  };

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Box sx={{ mb: { xs: 1, md: 0 } }}>
          <Button
            variant="outlined"
            color="gray"
            startIcon={<UndoIcon />}
            onClick={onNavigateToListPage}
            sx={{ fontWeight: 600, mb: 2 }}
          >
            بازگشت به لیست درخواست‌ها
          </Button>
        </Box>

        {requestId ? (
          <Grid container spacing={{ xs: 2, md: 2.5 }} sx={{ mb: 2 }}>
            <Grid item xs={12} md={8} lg={6}>
              <PaymentSummaryWidget compact={Boolean(invoiceId)} />
            </Grid>
            <Grid item xs={12}>
              <CustomerPricingActionPanel requestId={requestId} />
            </Grid>
            <Grid item xs={12} md={8} lg={6}>
              <RequestInvoicesPaymentPanel requestInfoId={requestId} compact />
            </Grid>
            {invoiceId && !Number.isNaN(invoiceId) ? (
              <Grid item xs={12} md={8} lg={6}>
                <CustomerInvoiceOnlinePayment invoiceId={invoiceId} />
              </Grid>
            ) : null}
          </Grid>
        ) : null}

        <Request
          onNavigateToListPage={onNavigateToListPage}
          source="Customer"
          onOpenPaymentModal={handleOpenPaymentModal}
          selectedPaymentData={selectedPaymentData}
        />
      </Grid>

      <Dialog
        open={paymentModalOpen}
        onClose={handleClosePaymentModal}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: "80vh",
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" component="span">
              انتخاب روش تسویه حساب
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClosePaymentModal}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {requestId && (
            <PaymentSelection
              requestId={requestId}
              isModal={true}
              onSelectPayment={handlePaymentSelected}
              onClose={handleClosePaymentModal}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default CustomerRequestsInfoPage;
